import React from "react";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";

import { Context, classDataPath } from "../../../teacherStore";
import Button from "../../../atoms/ActiveLearning/Button";
import TeacherHeader from "../../../organisms/teacher/TeacherHeader";
import Lesson1 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson1";
import Lesson2 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson2";
import Lesson3 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson3";
import Lesson4 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson4";
import Lesson5 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson5";
import Lesson6 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson6";
import Lesson7 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson7";
import Lesson8 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson8";
import Lesson9 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson9";
import Lesson10 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson10";
import Lesson11 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson11";
import Lesson12 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson12";
import Lesson13 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson13";
import Lesson14 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson14";
import Lesson15 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson15";
import { ReactComponent as IconArrowDown } from "../../../assets/images/ActiveLearning/icon_arrow_down.svg";

import styles from "./ActiveLearningClassDataContents.module.scss";

export const ActiveLearningClassDataContents = () => {
  const { state } = useContext(Context);
  const [materialCode, setMaterialCode] = useState<"ECS001" | "ECS002">(
    "ECS001",
  );

  const allStudents = state.classes_by_grade.flatMap(
    classes => classes.students,
  );

  const lessonComponentsRound1 = [
    {
      no: "01",
      component: (
        <Lesson1
          materialCode={materialCode}
          lessonNo={1}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
          activeLearningThemes={state.active_learning_themes}
        />
      ),
    },
    {
      no: "02",
      component: (
        <Lesson2
          materialCode={materialCode}
          lessonNo={2}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "03",
      component: (
        <Lesson3
          materialCode={materialCode}
          lessonNo={3}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "04",
      component: (
        <Lesson4
          materialCode={materialCode}
          lessonNo={4}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "05",
      component: (
        <Lesson5
          materialCode={materialCode}
          lessonNo={5}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "06",
      component: (
        <Lesson6
          materialCode={materialCode}
          lessonNo={6}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
          students={allStudents}
        />
      ),
    },
    {
      no: "07",
      component: (
        <Lesson7
          materialCode={materialCode}
          lessonNo={7}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "08",
      component: (
        <Lesson8
          materialCode={materialCode}
          lessonNo={8}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "09",
      component: (
        <Lesson9
          materialCode={materialCode}
          lessonNo={9}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "10",
      component: (
        <Lesson10
          materialCode={materialCode}
          lessonNo={10}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
          students={allStudents}
        />
      ),
    },
    {
      no: "11",
      component: (
        <Lesson11
          materialCode={materialCode}
          lessonNo={11}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
  ];
  const lessonComponentsRound2 = [
    {
      no: "01",
      component: (
        <Lesson1
          materialCode={materialCode}
          lessonNo={1}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
          activeLearningThemes={state.active_learning_themes}
        />
      ),
    },
    {
      no: "02",
      component: (
        <Lesson12
          materialCode={materialCode}
          lessonNo={2}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "03",
      component: (
        <Lesson13
          materialCode={materialCode}
          lessonNo={3}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "04",
      component: (
        <Lesson14
          materialCode={materialCode}
          lessonNo={4}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "05",
      component: (
        <Lesson4
          materialCode={materialCode}
          lessonNo={5}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "06",
      component: (
        <Lesson5
          materialCode={materialCode}
          lessonNo={6}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "07",
      component: (
        <Lesson6
          materialCode={materialCode}
          lessonNo={7}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
          students={allStudents}
        />
      ),
    },
    {
      no: "08",
      component: (
        <Lesson7
          materialCode={materialCode}
          lessonNo={8}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "09",
      component: (
        <Lesson8
          materialCode={materialCode}
          lessonNo={9}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "10",
      component: (
        <Lesson9
          materialCode={materialCode}
          lessonNo={10}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
    {
      no: "11",
      component: (
        <Lesson10
          materialCode={materialCode}
          lessonNo={11}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
          students={allStudents}
        />
      ),
    },
    {
      no: "12",
      component: (
        <Lesson15
          materialCode={materialCode}
          lessonNo={12}
          activeLearningMaterialLessons={
            state.active_learning_material_lessons_data
          }
          activeLearningAnswers={state.active_learning_student_answers}
        />
      ),
    },
  ];

  const selectedRoundComponents =
    materialCode === "ECS001" ? lessonComponentsRound1 : lessonComponentsRound2;

  const links = [
    {
      name: `クラスデータ`,
      to: classDataPath,
      search: "?isActiveLearning=true",
    },
    {
      name: `${state.active_learning_student_answers?.last_name}${state.active_learning_student_answers?.first_name}`,
      to: "#",
    },
  ];

  return (
    <div className={`${styles.wrapper} isTeacher`}>
      <TeacherHeader links={links} />
      <div className={styles.header}>
        <div className={styles.inner}>
          <Link
            className={styles.return}
            to={`${classDataPath}?isActiveLearning=true`}
          >
            くクラス選択に戻る
          </Link>
          <ul className={styles.roundList}>
            <li className={styles.round}>
              <Button
                variant={materialCode === "ECS001" ? "primary" : "secondary"}
                width={"240px"}
                height={"40px"}
                fontSize={"14px"}
                handleClick={() => setMaterialCode("ECS001")}
              >
                1周目
              </Button>
            </li>
            <li className={styles.round}>
              <Button
                variant={materialCode === "ECS002" ? "primary" : "secondary"}
                width={"240px"}
                height={"40px"}
                fontSize={"14px"}
                handleClick={() => setMaterialCode("ECS002")}
              >
                2周目
              </Button>
            </li>
          </ul>
          <ul className={styles.anchorList}>
            {selectedRoundComponents.map(lesson => (
              <li key={`lesson${lesson.no}`} className={styles.anchor}>
                <a href={`#lesson${lesson.no}`}>
                  <Button
                    variant={"secondary"}
                    width={"103px"}
                    height={"34px"}
                    fontSize={"12px"}
                  >
                    {`Lesson${lesson.no}`}
                    <IconArrowDown />
                  </Button>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <ul className={styles.lessonList}>
        {selectedRoundComponents.map(lesson => (
          <li
            key={`lesson${lesson.no}`}
            id={`lesson${lesson.no}`}
            className={styles.lesson}
          >
            {lesson.component}
          </li>
        ))}
      </ul>
    </div>
  );
};
export default ActiveLearningClassDataContents;
